import React from "react";
import g from "../../img/settings/g4.png";
import ch from "../../img/settings/ch.png";
import "./Settings.sass"

const Settings = ({setThemeIsDark, themeIsDark}) => {
    return(
        <section className={'settings main-bg ' + (themeIsDark ? 'dark-theme' : "white-theme")}>
            <div className="settings__bg-header">
                <div className="settings__header">
                    <div className="settings__title title">
                        <h1>Ваши настройки</h1>
                        <h3>Добро пожаловать на страницу настроек, здесь вы можете сделать нашу соц сеть менее ущербной для ваших глаз. Приятного дня!!!</h3>
                    </div>
                    <div className="settings__subtitle">
                        <div><img src={g} alt=""/></div>
                    </div>
                </div>
            </div>
            <div className="settings__container container">
                <div className="settings__main-blocks">
                    <p className="title-information settings__margin main-text">Изменение темы</p>
                    <div className="settings__themes-buttons settings__margin">
                        <p className='main-text'>Выберите тему:</p>
                        {themeIsDark ?
                            <>
                                <div className='settings__button white'>
                                    <span className='settings__checkpoint settings__big-round'></span>
                                    <button className="settings__checkpoint" onClick={() => setThemeIsDark(false)}></button>
                                </div>
                                <div className={"settings__button settings__your-theme dark"}>
                                    <button className="settings__checkpoint"><img src={ch} alt=""/></button>
                                </div>
                            </>
                            :
                            <>
                                <div className={"settings__button settings__your-theme white"}>
                                    <button className="settings__checkpoint"><img src={ch} alt=""/></button>
                                </div>
                                <div className='settings__button dark'>
                                    <span className='settings__checkpoint settings__big-round'></span>
                                    <button className="settings__checkpoint" onClick={() => setThemeIsDark(true)}></button>
                                </div>
                            </>
                        }
                    </div>
                    <p className='additional-text settings__margin'>*Сменив тему вы можете получить гораздо больше удовольствия, хотя если вы находитесь в нашей сети, то вы уже в максимальном экстазе</p>
                </div>
                <div className="settings__main-blocks">
                    <p className="title-information settings__margin main-text">Изменение языка</p>
                    <div className="settings__language settings__margin">
                        <p className='main-text'>Выберите язык:</p>
                        <p>Русский</p>
                    </div>
                    <p className='additional-text settings__margin'>*К сожалению наша социальная сеть не поднялась до мирового уровня, поэтому радуемся нашему поистине могущественному русскому языку</p>
                </div>
            </div>
        </section>
    )
};

export default Settings